import React from 'react';
import { node, oneOfType, string, object, func, bool } from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
const noop = () => { };
const Checkbox = ({ isDisabled, disabled, checked, name, value, id, icon, onChange, className, style, label, testId, }) => (React.createElement("label", { style: style, className: setClass([
        (disabled || isDisabled) && 'b-not-allowed',
        'b-checkbox',
        'b-txt',
        className,
    ]), htmlFor: id || '' },
    React.createElement("input", { type: "checkbox", name: name, className: "b-checkbox-input", id: id, value: value, onChange: noop, disabled: isDisabled || disabled, checked: checked }),
    React.createElement("span", { className: "b-checkbox-square", onClick: (e) => {
            if (disabled || isDisabled) {
                return null;
            }
            onChange(e);
            return null;
        } },
        React.createElement(Icon, { name: icon || 'check' })),
    label ? (React.createElement("a", { className: setClass(disabled || isDisabled ? 'b-link-disabled' : ''), href: "", onClick: (e) => {
            e.preventDefault();
            if (disabled || isDisabled) {
                return null;
            }
            onChange(e);
            return null;
        }, "data-testid": testId }, label)) : null));
Checkbox.propTypes = {
    className: string,
    style: object,
    name: string,
    id: string,
    onChange: func,
    isDisabled: bool,
    disabled: bool,
    checked: bool,
    value: string,
    icon: string,
    label: oneOfType([node, string]),
    testId: string,
};
Checkbox.defaultProps = {
    className: '',
    style: {},
    icon: 'check',
    name: '',
    id: '',
    onChange: () => { },
    isDisabled: false,
    disabled: false,
    value: '',
    checked: false,
    label: '',
    testId: undefined,
};
export default Checkbox;
